var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconIcGnbLogoColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 29,
    viewBox: "0 0 150 29",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "l5tg4jcy6a",
    d: "M0 0h21.545v22.294H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#888889",
    d: "M33.364 5.878v5.698h6.476v16.099h7.456V11.576h6.475V5.878zM68.49 15.982c-.506.447-1.264.67-2.275.67h-2.717v-5.107h2.717c1.011 0 1.77.224 2.275.67.506.447.758 1.074.758 1.884 0 .809-.252 1.437-.758 1.883m7.203 2.195c.716-1.162 1.074-2.522 1.074-4.078 0-1.661-.41-3.114-1.232-4.36-.822-1.245-1.99-2.2-3.507-2.864-1.517-.665-3.296-.997-5.339-.997H56.043v21.796h7.455v-5.48h2.023l3.759 5.48h7.96l-4.643-6.725c1.347-.685 2.379-1.608 3.096-2.772"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.864 5.879)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mosqgtgd9b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#l5tg4jcy6a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.216 11.77c0 1.598-.29 2.76-.869 3.487-.579.727-1.417 1.09-2.511 1.09-1.096 0-1.933-.363-2.512-1.09-.58-.726-.869-1.889-.869-3.488V0H0v11.988c0 3.259.947 5.79 2.843 7.597 1.896 1.806 4.538 2.709 7.93 2.709 3.39 0 6.033-.903 7.929-2.71 1.895-1.805 2.843-4.337 2.843-7.596V0h-7.33v11.77z",
    fill: "#888889",
    mask: "url(#mosqgtgd9b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115.206 11.328c1.853 0 3.464.851 4.833 2.553l4.707-4.141c-1.095-1.412-2.484-2.492-4.17-3.24-1.685-.746-3.6-1.12-5.749-1.12-2.338 0-4.444.483-6.319 1.448-1.874.966-3.343 2.315-4.406 4.048-1.064 1.734-1.596 3.7-1.596 5.9s.532 4.168 1.596 5.9c1.063 1.735 2.532 3.083 4.406 4.049 1.875.965 3.981 1.448 6.32 1.448 2.147 0 4.063-.374 5.749-1.121 1.685-.747 3.074-1.827 4.17-3.239l-4.708-4.141c-1.369 1.702-2.98 2.553-4.833 2.553-1.559 0-2.811-.492-3.76-1.479-.947-.985-1.421-2.309-1.421-3.97 0-1.66.474-2.984 1.422-3.97.948-.985 2.2-1.478 3.76-1.478M140.712 15.469l8.846-9.59h-8.12l-7.265 7.908V5.879h-7.33v21.795h7.33v-5.386l1.674-1.838 5.528 7.224H150z",
    fill: "#888889"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E75297",
    d: "M31.838 27.855 21.664 0l-8.618 7.866 7.3 19.989z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A6E9",
    d: "M0 27.855h11.491l7.3-19.99L10.174 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F9BE00",
    d: "m10.173 0 5.746 15.732L21.664 0z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcGnbLogoColor);
export default __webpack_public_path__ + "static/media/icon-ic-gnb-logo-color.2b502996aa312c55d11dfb3da8cacbb2.svg";
export { ForwardRef as ReactComponent };